import { apiClient } from '../../../api/client'
import type { Group, GroupMember, GroupUpdate } from '../types'

const BASE = '/management/groups'

/** Kullanıcı grupları + aktif üye sayıları (122). Katalog küçüktür — sayfalama yok. */
export async function getGroups(): Promise<Group[]> {
  const { data } = await apiClient.get<Group[]>(BASE)
  return data
}

/** Grup adını (TR/EN) günceller — grup için düzenlenebilen tek şey. */
export async function updateGroup(id: number, body: GroupUpdate): Promise<Group> {
  const { data } = await apiClient.put<Group>(`${BASE}/${id}`, body)
  return data
}

/** Gruptaki aktif kullanıcılar (ada göre sıralı). */
export async function getGroupMembers(id: number): Promise<GroupMember[]> {
  const { data } = await apiClient.get<GroupMember[]>(`${BASE}/${id}/members`)
  return data
}

/** Kullanıcıyı gruba ekler (zaten üyeyse sunucu işlem yapmaz). */
export async function addGroupMember(id: number, userId: number): Promise<void> {
  await apiClient.post(`${BASE}/${id}/members`, { userId })
}

/** Kullanıcıyı gruptan çıkarır. */
export async function removeGroupMember(id: number, userId: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}/members/${userId}`)
}
